var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('ec-page-heading',{staticClass:"intro-text wrapper pt-5 pb-5",attrs:{"paragraph":_vm.paragraph,"sub-title":_vm.subTitle,"title":_vm.pageTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }